import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32cc7924")

_pushScopeId("data-v-32cc7924")
const _hoisted_1 = { class: "shortcuts" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Table, {
      data: _ctx.rows,
      columns: _ctx.columns,
      keyField: "description"
    }, {
      checkbox: _withId((props) => [
        _createVNode(_component_Checkbox, {
          modelValue: props.row.checkbox,
          "onUpdate:modelValue": ($event: any) => (props.row.checkbox = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _: 1
    }, 8, ["data", "columns"])
  ]))
})